<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> Informations sur le correspondant </div>
        <div class="modal-body">
            <div class="infos" *ngIf="correspondantInfos">
                <div class="identite-civile">
                    <div class="nom-prenom">
                        {{correspondantInfos.titre ? correspondantInfos.titre : ''}} {{correspondantInfos.prenom ?
                        correspondantInfos.prenom : ''}} {{correspondantInfos.nom ? correspondantInfos.nom : ''}}
                    </div>
                    <div class="specialite">
                        {{correspondantInfos.professionName}}
                    </div>
                    <div class="specialite">
                        {{correspondantInfos.specialiteName}}
                    </div>
                    <div class="secteur">
                        Secteur : <span>{{correspondantInfos.secteur ? correspondantInfos.secteur : '- -'}}</span>
                    </div>
                </div>
                <div class="adresse-telephone">
                    <div class="adresses">
                        <div class="adresse1">
                            Adresse : <span>{{correspondantInfos.adresse1 ? correspondantInfos.adresse1 : '- -'}}</span>
                        </div>
                        <div class="adresse2" *ngIf="correspondantInfos.adresse2">
                            Adresse 2 : <span>{{correspondantInfos.adresse2}}</span>
                        </div>
                        <div class="adresse3" *ngIf="correspondantInfos.adresse3">
                            Adresse 3 : <span>{{correspondantInfos.adresse3}}</span>
                        </div>
                        <div class='code-ville'>
                            {{correspondantInfos.codePostal ? correspondantInfos.codePostal : '- -'}}
                            {{correspondantInfos.ville ? correspondantInfos.ville : '- -'}}
                        </div>
                    </div>
                    <div class="telephones">
                        <div class="telephone1">
                            Téléphone 1 : <span>{{correspondantInfos.telephone1 ? correspondantInfos.telephone1 : '- -'}}</span>
                        </div>
                        <div class="telephone2" *ngIf="correspondantInfos.telephone2">
                            Téléphone 2 : <span>{{correspondantInfos.telephone2}}</span>
                        </div>
                        <div class="portable1">
                            Portable 1 : <span>{{correspondantInfos.portable1 ? correspondantInfos.portable1 : '- -'}}</span>
                        </div>
                        <div class="portable2" *ngIf="correspondantInfos.portable2">
                            Portable 2 : <span>{{correspondantInfos.portable2}}</span>
                        </div>
                        <div class="tel-perso" *ngIf="correspondantInfos.telephonePerso">
                            Téléphone personnel : <span>{{correspondantInfos.telephonePerso}}</span>
                        </div>
                        <div class="fax" *ngIf="correspondantInfos.fax">
                            Ligne fax : <span>{{correspondantInfos.fax}}</span>
                        </div>
                    </div>
                </div>
                <div class="emails">
                    <div class="email1">
                        Adresse e-Mail : <span>{{correspondantInfos.email1 ? correspondantInfos.email1 : '- -'}}</span>
                    </div>
                    <div class="email2" *ngIf="correspondantInfos.email2">
                        Adresse(s) e-Mail MSS : <span style="white-space: pre;">{{getMails(correspondantInfos.email2)}}</span>
                    </div>
                </div>
                <div class="hprim-cript">
                    <div class="hprim" *ngIf="correspondantInfos.passwordHprim">
                        Mot de passe HPRIM : <span>{{correspondantInfos.passwordHprim}}</span>
                    </div>
                    <div class="api-crypt" *ngIf="correspondantInfos.nomApiCrypt">
                        Nom API Crypt : <span>{{correspondantInfos.nomApiCrypt}}</span>
                    </div>
                    <div class="hprim" *ngIf="correspondantInfos.adresseApiCrypt">
                        Adresse API Crypt : <span>{{correspondantInfos.adresseApiCrypt}}</span>
                    </div>
                    <div class="rpps" *ngIf="correspondantInfos.rpps">
                        RPPS : <span>{{correspondantInfos.rpps}}</span>
                    </div>
                </div>
                <div class="categorie" *ngIf="correspondantInfos.categorie">
                  <div>
                    Categorie : <span>{{correspondantInfos.categorie}}</span>
                  </div>
                </div>
                <div class="info-compl">
                    <p>Informations complémentaires : <span>{{correspondantInfos.infos ?
                            correspondantInfos.infos : '- -'}}</span></p>
                </div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeAlertModal(correspondantInfos)" [backgroundColor]="'var(--primary)'">
                    Enregistrer dans mon répertoire</frg-button>
                <frg-button (activated)="closeAlertModal()" [backgroundColor]="'var(--darkest-primary)'">
                    Fermer</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>
